import { useShowResponseStatus } from '@/shared';

import { useGetRemotePaymentMethodsByPaymentSystemQuery } from '../store/remote-payment-methos-api';

export const useGetRemoteMethods = (paymentSystemId: number) => {
  const { data: remoteMethods, isLoading, isError } = useGetRemotePaymentMethodsByPaymentSystemQuery({ paymentSystemId });

  useShowResponseStatus({
    isError,
  });

  return {
    remoteMethods: remoteMethods ?? [],
    isLoading,
  };
};
